@if (ratingControls()) {
  <div
    class="rating-buttons d-flex gap-2 flex-wrap"
    [class.m-auto]="marginAuto()"
    [class.flex-column]="isButtonTemplate()"
  >
<!--    @if (showRatingNumber()) {-->
<!--      <span class="item-rating-numbers bg-dark-blue text-white px-2">{{-->
<!--        Math.abs(qualification())-->
<!--      }}</span>-->
<!--    }-->
    <div
      class="rating-buttons d-flex justify-content-md-center justify-content-start flex-wrap gap-1"
      [class.m-auto]="marginAuto()"
    >
      @for (rating of ratingControls(); track $index) {
        <label class="radio-group mb-0" [class.gray]="gray()">
          <input
            [name]="randomStrings()[$index] + $index"
            [value]="$index + 1"
            (click)="!disabled() ? setRating($index + 1) : $event.preventDefault()"
            [formControl]="toFormControl(rating)"
            type="radio"
          />
          <span class="checkmark" [style.width]="size()" [style.height]="size()"></span>
        </label>
      }
    </div>
    <ng-template *ngTemplateOutlet="buttonTemplate()"></ng-template>
  </div>
}
